import {
    isNumber
} from "../../../../common/utils";

// 格式化相关处理

export function nColor(n) {
    return n < 0 ? '#090' : '#f00'  // TODO: 改为可配置的
}

export function getDataIndex(params) {
    const params_0 = params[0];
    const dataIndex = params_0 ? params_0.dataIndex : params.dataIndex
    return isNumber(dataIndex) && dataIndex >= 0 ? dataIndex : -1
}
